import * as React from "react";
const SvgFiRrCucumber = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cucumber_svg__a)">
      <path
        fill="#062147"
        d="M20 7.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 .001M12.5 14a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12.5 14m10.947-4.148a22 22 0 0 1-1.003 2.491c.337.275.556.688.556 1.157a1.5 1.5 0 0 1-1.5 1.5c-.178 0-.346-.036-.504-.093a21.23 21.23 0 0 1-8.05 7.217c.032.121.054.245.054.376a1.5 1.5 0 0 1-1.5 1.5c-.534 0-1-.281-1.265-.701-.126.045-.248.096-.375.138a11.2 11.2 0 0 1-3.528.558c-2.791 0-5.454-1.004-6.146-3.026-.716-2.106.707-4.431 2.879-6.058A1.5 1.5 0 0 1 3 14.5 1.5 1.5 0 0 1 4.5 13c.436 0 .826.189 1.1.487.089-.036.178-.076.268-.109 2.095-.77 3.533-1.639 4.665-2.819.82-.787 1.483-1.708 2.065-2.867A1.5 1.5 0 0 1 12 6.501a1.5 1.5 0 0 1 1.5-1.5c.082 0 .16.011.239.024 1.485-3.178 4.539-5.755 7.234-4.84h.002c2.916.996 3.71 5.925 2.472 9.666zm-1.898-.629c.953-2.88.315-6.617-1.218-7.144a1.5 1.5 0 0 0-.483-.077c-1.538 0-3.667 2.048-4.588 4.553-.868 2.362-1.922 4.084-3.314 5.418-1.305 1.362-3.026 2.415-5.39 3.282-2.781 1.021-5 3.532-4.477 5.068.528 1.549 4.267 2.187 7.142 1.22 5.9-1.986 10.394-6.477 12.328-12.32"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cucumber_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCucumber;
